<div class="alert alert-warning w-50 mt-5" role="alert" style="margin-left: 25%;">
    <h4 class="alert-heading">Error!</h4>
    <p>Single Site Api service is not started, please contact system administrator.</p>
    <hr>
</div>